import { GanttViewType } from '@worktile/gantt';
import type { GanttI18nLocaleConfig } from '@worktile/gantt';
import { GANTT_GLOBAL_CONFIG, GANTT_I18N_LOCALE_TOKEN } from '@worktile/gantt';
import type { Provider } from '@angular/core';
import { fr } from 'date-fns/locale';

/**
 * Locale française pour ngx-gantt : libellés des vues et formats des graduations.
 * Fournie via GANTT_I18N_LOCALE_TOKEN (multi) et sélectionnée par
 * GANTT_GLOBAL_CONFIG.locale = 'fr-fr'.
 */
const frFrLocale: GanttI18nLocaleConfig = {
  id: 'fr-fr',
  dateLocale: fr,
  views: {
    [GanttViewType.hour]: {
      label: 'Heures',
      tickFormats: { period: 'd MMM', unit: 'HH:mm' },
    },
    [GanttViewType.day]: {
      label: 'Jour',
      tickFormats: { period: 'MMM yyyy', unit: 'd' },
    },
    [GanttViewType.week]: {
      label: 'Semaine',
      tickFormats: { period: 'yyyy', unit: 'wo' },
    },
    [GanttViewType.month]: {
      label: 'Mois',
      tickFormats: { period: "yyyy 'T'Q", unit: 'MMM' },
    },
    [GanttViewType.quarter]: {
      label: 'Trimestre',
      tickFormats: { period: 'yyyy', unit: "yyyy 'T'Q" },
    },
    [GanttViewType.year]: {
      label: 'Année',
      tickFormats: { unit: 'yyyy' },
    },
  },
};

/** Providers à ajouter au niveau racine de l'application. */
export const GANTT_FR_PROVIDERS: Provider[] = [
  { provide: GANTT_GLOBAL_CONFIG, useValue: { locale: 'fr-fr' } },
  { provide: GANTT_I18N_LOCALE_TOKEN, useValue: frFrLocale, multi: true },
];
